import { useRouter } from 'next/router'

const useNextRouterHook = () => {
    const router = useRouter();
    const routerTo = (url) => router.push(url);
    return routerTo;
}

export default useNextRouterHook;